export default () => {
  const pfmWrappers = document.querySelectorAll('.product-f-measurements');

  pfmWrappers.forEach((pfmWrapper) => {
    const els = pfmWrapper.querySelectorAll('.product-f-measurements__dimensions');
    const measurementSystem = window.getMeasurementSystem();
    els.forEach((el) => {
      if (el.dataset.measurementSystem === measurementSystem) {
        el.classList.remove('d-none');
        el.classList.add('active');
      } else {
        el.classList.add('d-none');
      }
    });
    pfmWrapper.classList.add('render-complete');
    pfmWrapper.dispatchEvent(new Event('pfm:render'));
  });
};
